<template>
    <div>
        <div class="form__page -pt-nav position-relative overflow-hidden ">

            <!-- <img src="@/assets/bg__allforms.png" alt="" class="form__allforms" /> -->


            <div class="container d-flex justify-content-center">
                <div class="form__page-content col-sm-20 form__allforms-content">
                    <div class="form__row">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-1">
                                Formularz zgłoszeniowy — etap II
                            </p>
                            <p class="text-20">
                                Program stypendialny dla uczniów
                            </p>
                        </div>
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-4">
                                Dane uczestnika konkursu <span class="form__label form__label--red">*</span>
                            </p>
                        </div>
                        <reporting-person />
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Informacje do wyświetlenia na profilu uczestnika
                            </p>
                        </div>
                        <StudentDataStep2 />
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Załączniki
                            </p>
                        </div>
                        <attachments-data />
                    </div>

                    <div class="form__row -pb-4 form__rights" v-if="!isParent">
                        <p class="text-center form__title heading-32">Oświadczenia</p>

                        <div class="heading-16 form__pt-24" v-for="contactTerm of contactTerms" :key="contactTerm.id">
                            <p v-if="!readMoreActivated[contactTerm.id]"
                                class="text-start heading-16 form__description">
                                <span v-html="contactTerm.description.slice(0, 158)"></span>
                                <span
                                    v-if="!readMoreActivated[contactTerm.id] && contactTerm.description.length - 1 > 251"
                                    class="text-start text-16" @click.prevent="checkmarkExpand([contactTerm.id])"> ...
                                    <span class="heading-16 cur-pointer"> rozwiń</span></span>
                            </p>
                            <p v-if="readMoreActivated[contactTerm.id]" class="form__description">
                                <span v-html="contactTerm.description"></span>
                                <span class="form__checkmark-collapse text-start heading-16 cur-pointer"
                                    v-if="readMoreActivated[contactTerm.id]"
                                    @click.prevent="checkmarkCollapse([contactTerm.id])"> zwiń</span>
                            </p>
                        </div>

                        <div class="form-check form__pt-24 d-flex align-items-center form__gap-16">
                            <input v-model="agreement_all" class="form-check-input" type="checkbox"
                                id="flexCheckDefault">
                            <label class="form-check-label heading-16" for="flexCheckDefault">
                                Zaznacz wszystkie
                            </label>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_1_error }" v-model="agreement_1"
                                    type="checkbox" id="flexCheckDefault-1">
                                <label class="form-check-label text-16" for="flexCheckDefault-1">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam, że wszystkie dane zamieszczone w niniejszym formularzu i w
                                        dokumentach do niego załączonych są zgodne z prawdą i stanem faktycznym oraz że
                                        podaję je dobrowolnie.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_1_error">
                                {{ agreement_1_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_2_error }" v-model="agreement_2"
                                    type="checkbox" id="flexCheckDefault-2">
                                <label class="form-check-label text-16" for="flexCheckDefault-2">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Potwierdzam, że zapoznałem się z regulaminem akcji „Enea Akademia Talentów” oraz
                                        załącznikami do niego, wyrażam zgodę na jego postanowienia i zobowiązuję się do
                                        przestrzegania określonych w nim zasad.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_2_error">
                                {{ agreement_2_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_3_error }" v-model="agreement_3"
                                    type="checkbox" id="flexCheckDefault-3">
                                <label class="form-check-label text-16" for="flexCheckDefault-3">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na przetwarzanie danych osobowych podanych w formularzu
                                        zgłoszeniowym oraz w dokumentach do niego załączonych w celach związanych z
                                        realizacją akcji, w tym w celu kontaktu z moją osobą, oceny zgłoszenia do
                                        udziału w akcji, zakwalifikowania mojego zgłoszenia do II etapu akcji,
                                        utworzenia profilu mojego profilu na stronie internetowej Akcji, umożliwienia
                                        głosowania Internautów na Zadanie konkursowe zgłoszone przeze mnie, wydania
                                        nagrody, ogłoszenia wyników, rozpatrzenia reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_3_error">
                                {{ agreement_3_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_4_error }" v-model="agreement_4"
                                    type="checkbox" id="flexCheckDefault-4">
                                <label class="form-check-label text-16" for="flexCheckDefault-4">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam i zapewniam, odpowiednio że:<br>
                                        a. wykonałem Zadanie konkursowe samodzielnie;<br>
                                        b. przysługują mi wszelkie autorskie prawa majątkowe do Zadania konkursowego;
                                        <br>
                                        c. Zadanie konkursowe nie jest w żaden sposób obciążone oraz nie narusza praw
                                        osób trzecich, w tym w szczególności praw autorskich, praw pokrewnych, praw
                                        zależnych oraz praw własności przemysłowej; <br>
                                        d. posiadam prawa do wykorzystania i rozpowszechniania w ramach Zadania
                                        konkursowego wizerunku i głosu osób trzecich, utworów stworzonych przez osoby
                                        trzecie, praw do artystycznych wykonań osób trzecich, jeśli wizerunki lub głosy
                                        tych osób, ich utwory lub artystyczne wykonania znajdują się na/zostały
                                        utrwalone w Zadaniu konkursowym w zakresie i na warunkach, aby możliwym było
                                        udzielenie licencji do Zadania konkursowego oraz sublicencji Organizatorowi i
                                        Współorganizatorowi na warunkach i w zakresie opisanym w Regulaminie Akcji Enea
                                        Akademia Talentów, w tym w szczególności w § 4 ust. 4 pkt 6.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_4_error">
                                {{ agreement_4_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_5_error }" v-model="agreement_5"
                                    type="checkbox" id="flexCheckDefault-5">
                                <label class="form-check-label text-16" for="flexCheckDefault-5">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Udzielam Organizatorowi i Współorganizatorowi nieodpłatnie licencji niewyłącznej
                                        do Zadania konkursowego i utrwalonego w nim artystycznego mojego wykonania
                                        (jeśli zostało utrwalone) – licencja w zakresie praw autorskich majątkowych i
                                        praw pokrewnych do Zadania konkursowego, a jeśli w Zadaniu konkursowym zostały
                                        utrwalone utwory stworzone przez osoby trzecie lub artystyczne wykonania osób
                                        trzecich – udzielam do nich nieodpłatnie sublicencji, na następujących polach
                                        eksploatacji:<br>
                                        a. utrwalanie i zwielokrotnianie Zadania konkursowego jakąkolwiek techniką, w
                                        tym na płycie CD, nośnikach elektronicznych, w formie drukowanej; <br>
                                        b. wprowadzanie Zadania konkursowego do pamięci komputera oraz przechowywanie
                                        Zadania konkursowego w pamięci komputera w celu wskazanym w lit. c poniżej;<br>
                                        c. wykorzystanie i rozpowszechnianie Zadania konkursowego oraz jego
                                        upublicznienie na stronie internetowej www.akademiatalentow.enea.pl.<br>
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_5_error">
                                {{ agreement_5_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_6_error }" v-model="agreement_6"
                                    type="checkbox" id="flexCheckDefault-6">
                                <label class="form-check-label text-16" for="flexCheckDefault-6">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam, iż licencja i sublicencja jest udzielana na czas trwania Akcji, a w
                                        przypadku wygranej - na okres do dnia 31 grudnia 2025 roku– tj. na czas do
                                        zakończenia programu stypendialnego.<br>
                                        Jednocześnie upoważniam Organizatora i Współorganizatora do wykonywania w moim
                                        imieniu oraz w imieniu osób, których utwory lub artystyczne wykonania zostały
                                        wykorzystane w Zadaniu konkursowym przysługujących Uczestnikowi i ww. osobom
                                        autorskich praw osobistych oraz do decydowania o przystąpieniu do
                                        rozpowszechniania Zadania konkursowego w sposób opisany wyżej oraz o oznaczeniu
                                        Zadania konkursowego imieniem i nazwiskiem Uczestnika lub o braku takiego
                                        oznaczenia.<br>
                                        W zakresie i czasie opisanym wyżej wyrażam także zgodę na wykorzystanie i
                                        rozpowszechnienie wizerunku i głosu oraz danych osobowych Uczestnika i osób
                                        trzecich, o ile zostały utrwalone w Zadaniu konkursowym

                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_6_error">
                                {{ agreement_6_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_7_error }" v-model="agreement_7"
                                    type="checkbox" id="flexCheckDefault-7">
                                <label class="form-check-label text-16" for="flexCheckDefault-7">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na zamieszczenie przesłanego Zdjęcia – zawierającego utrwalenie
                                        mojego wizerunku oraz publikację moich danych tj. imienia, pierwszej litery
                                        nazwiska, miejscowości zamieszkania, klasy, do której uczęszczam, informacji
                                        podanych w sekcji Krótka charakterystyka Uczestnika i jego największe
                                        osiągnięcia, które zostaną zamieszczone na stronie Enei Akademii Talentów w
                                        ramach mojego profilu (z Formularza zgłoszeniowego II Etapu),
                                        www.akademiatalentow.enea.pl, celem stworzenia profilu i umożliwienia
                                        Internautom głosowania na mnie i moje Zadanie konkursowe – na czas trwania Akcji
                                        oraz w ww. zakresie i celu wyraża zgodę na przetwarzanie ww. danych osobowych.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_7_error">
                                {{ agreement_7_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_8_error }" v-model="agreement_8"
                                    type="checkbox" id="flexCheckDefault-8">
                                <label class="form-check-label text-16" for="flexCheckDefault-8">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        W przypadku wygranej przez Uczestnika wyrażam zgodę na zamieszczenie przesłanego
                                        Zdjęcia zawierającego utrwalenie wizerunku Uczestnika oraz publikację danych
                                        Uczestnika, o których mowa w pkt 7) powyżej, na stronie internetowej Akcji pod
                                        adresem www.akademiatalentow.enea.pl w zakładce Zwycięzcy Akcji 2024/2025 na
                                        okres do dnia 31 grudnia 2025 roku – tj. na czas do zakończenia programu
                                        stypendialnego oraz w ww. zakresie i celu wyrażam zgodę na przetwarzanie ww.
                                        danych osobowych.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_8_error">
                                {{ agreement_8_error }}
                            </div>
                        </div>
                    </div>

                    <div class="form__row -pb-4 form__rights" v-if="isParent">
                        <p class="text-center form__title heading-32">Oświadczenia</p>

                        <div class="heading-16 form__pt-24" v-for="contactTerm of contactTerms" :key="contactTerm.id">
                            <p v-if="!readMoreActivated[contactTerm.id]"
                                class="text-start heading-16 form__description">
                                <span v-html="contactTerm.description.slice(0, 158)"></span>
                                <span
                                    v-if="!readMoreActivated[contactTerm.id] && contactTerm.description.length - 1 > 251"
                                    class="text-start text-16" @click.prevent="checkmarkExpand([contactTerm.id])">...
                                    <span class="heading-16 cur-pointer">rozwiń</span></span>
                            </p>
                            <p v-if="readMoreActivated[contactTerm.id]" class="form__description">
                                <span v-html="contactTerm.description"></span>
                                <span class="form__checkmark-collapse text-start heading-16 cur-pointer"
                                    v-if="readMoreActivated[contactTerm.id]"
                                    @click.prevent="checkmarkCollapse([contactTerm.id])">zwiń</span>
                            </p>
                        </div>

                        <div class="form-check form__pt-24 d-flex align-items-center form__gap-16">
                            <input v-model="agreement_all" class="form-check-input" type="checkbox"
                                id="flexCheckDefault">
                            <label class="form-check-label heading-16" for="flexCheckDefault">
                                Zaznacz wszystkie
                            </label>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_1_error }" v-model="agreement_1"
                                    type="checkbox" id="flexCheckDefault-1">
                                <label class="form-check-label text-16" for="flexCheckDefault-1">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam, że wszystkie dane zamieszczone w niniejszym formularzu i w
                                        dokumentach do niego załączonych są zgodne z prawdą i stanem faktycznym oraz że
                                        podaję je dobrowolnie.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_1_error">
                                {{ agreement_1_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_2_error }" v-model="agreement_2"
                                    type="checkbox" id="flexCheckDefault-2">
                                <label class="form-check-label text-16" for="flexCheckDefault-2">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Potwierdzam, że zapoznałem się z regulaminem akcji „Enea Akademia Talentów” oraz
                                        załącznikami do niego, wyrażam zgodę na jego postanowienia i zobowiązuję się do
                                        przestrzegania określonych w nim zasad.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_2_error">
                                {{ agreement_2_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_3_error }" v-model="agreement_3"
                                    type="checkbox" id="flexCheckDefault-3">
                                <label class="form-check-label text-16" for="flexCheckDefault-3">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na uczestnictwo mojej córki / mojego syna / podopiecznego (dalej
                                        „Uczestnik”) w akcji „Enea Akademia Talentów”.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_3_error">
                                {{ agreement_3_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_4_error }" v-model="agreement_4"
                                    type="checkbox" id="flexCheckDefault-4">
                                <label class="form-check-label text-16" for="flexCheckDefault-4">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na przetwarzanie danych osobowych mojej córki / mojego syna /
                                        podopiecznego podanych w formularzu zgłoszeniowym oraz w dokumentach do niego
                                        załączonych w celach związanych z realizacją akcji, w tym w celu kontaktu z
                                        uczestnikiem, oceny zgłoszenia do udziału w akcji, zakwalifikowania ucznia do II
                                        etapu akcji, utworzenia profilu Uczestnika na stronie internetowej Akcji,
                                        umożliwienia głosowania Internautów na Zadanie konkursowe zgłoszone przez
                                        Uczestnika oraz na Uczestnika wydania nagrody, ogłoszenia wyników, rozpatrzenia
                                        reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_4_error">
                                {{ agreement_4_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_5_error }" v-model="agreement_5"
                                    type="checkbox" id="flexCheckDefault-5">
                                <label class="form-check-label text-16" for="flexCheckDefault-5">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu
                                        zgłoszeniowym oraz w dokumentach do niego załączonych w celach związanych z
                                        realizacją akcji, w tym w celu kontaktu ze mną jako wnioskodawcą, oceny
                                        zgłoszenia do udziału w akcji, zakwalifikowania ucznia do II etapu akcji,
                                        wydania nagrody, ogłoszenia wyników, rozpatrzenia reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_5_error">
                                {{ agreement_5_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_6_error }" v-model="agreement_6"
                                    type="checkbox" id="flexCheckDefault-6">
                                <label class="form-check-label text-16" for="flexCheckDefault-6">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam i zapewniam, odpowiednio że:<br>
                                        a. Uczestnik wykonał Zadanie konkursowe samodzielnie;<br>
                                        b. Uczestnikowi przysługują wszelkie autorskie prawa majątkowe do Zadania
                                        konkursowego; <br>
                                        c. Zadanie konkursowe nie jest w żaden sposób obciążone oraz nie narusza praw
                                        osób trzecich, w tym w szczególności praw autorskich, praw pokrewnych, praw
                                        zależnych oraz praw własności przemysłowej; <br>
                                        d. Uczestnik posiada prawa do wykorzystania i rozpowszechniania w ramach Zadania
                                        konkursowego wizerunku i głosu osób trzecich, utworów stworzonych przez osoby
                                        trzecie, praw do artystycznych wykonań osób trzecich, jeśli wizerunki lub głosy
                                        tych osób, ich utwory lub artystyczne wykonania znajdują się na/zostały
                                        utrwalone w Zadaniu konkursowym w zakresie i na warunkach, aby możliwym było
                                        udzielenie licencji do Zadania konkursowego oraz sublicencji Organizatorowi i
                                        Współorganizatorowi na warunkach i w zakresie opisanym w Regulaminie akcji Enea
                                        Akademia Talentów, w tym w szczególności w § 4 ust. 4 pkt 6.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_6_error">
                                {{ agreement_6_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_7_error }" v-model="agreement_7"
                                    type="checkbox" id="flexCheckDefault-7">
                                <label class="form-check-label text-16" for="flexCheckDefault-7">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Udzielam Organizatorowi i Współorganizatorowi nieodpłatnie licencji niewyłącznej
                                        do Zadania konkursowego i utrwalonego w nim artystycznego wykonania Uczestnika
                                        (jeśli zostało utrwalone) – licencja w zakresie praw autorskich majątkowych i
                                        praw pokrewnych do Zadania konkursowego, a jeśli w Zadaniu konkursowym zostały
                                        utrwalone utwory stworzone przez osoby trzecie lub artystyczne wykonania osób
                                        trzecich – udziela do nich nieodpłatnie sublicencji, na następujących polach
                                        eksploatacji:<br>
                                        a. utrwalanie i zwielokrotnianie Zadania konkursowego jakąkolwiek techniką, w
                                        tym na płycie CD, nośnikach elektronicznych, w formie drukowanej; <br>
                                        b. wprowadzanie Zadania konkursowego do pamięci komputera oraz przechowywanie
                                        Zadania konkursowego w pamięci komputera w celu wskazanym w lit. c poniżej;<br>
                                        c. wykorzystanie i rozpowszechnianie Zadania konkursowego oraz jego
                                        upublicznienie na stronie internetowej www.akademiatalentow.enea.pl.<br>

                                        Licencja i sublicencja jest udzielana na czas trwania Akcji, a w przypadku
                                        wygranej przez Uczestnika - na okres do dnia 31 grudnia 2025 roku– tj. na czas
                                        do zakończenia programu stypendialnego.<br>
                                        Jednocześnie Wnioskodawca upoważnia Organizatora i Współorganizatora do
                                        wykonywania w imieniu Uczestnika oraz w imieniu osób, których utwory lub
                                        artystyczne wykonania zostały wykorzystane w Zadaniu konkursowym przysługujących
                                        Uczestnikowi i ww. osobom autorskich praw osobistych oraz do decydowania o
                                        przystąpieniu do rozpowszechniania Zadania konkursowego w sposób opisany wyżej
                                        oraz o oznaczeniu Zadania konkursowego imieniem i nazwiskiem Uczestnika lub o
                                        braku takiego oznaczenia.<br>
                                        W zakresie i czasie opisanym wyżej Wnioskodawca wyraża także zgodę na
                                        wykorzystanie i rozpowszechnienie wizerunku i głosu oraz danych osobowych
                                        Uczestnika i osób trzecich, o ile zostały utrwalone w Zadaniu konkursowym.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_7_error">
                                {{ agreement_7_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_8_error }" v-model="agreement_8"
                                    type="checkbox" id="flexCheckDefault-8">
                                <label class="form-check-label text-16" for="flexCheckDefault-8">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Wyrażam zgodę na zamieszczenie przesłanego Zdjęcia – zawierającego utrwalenie
                                        wizerunku Uczestnika oraz publikację danych Uczestnika tj. imienia, pierwszej
                                        litery nazwiska, miejscowości zamieszkania Uczestnika, klasy, do której
                                        Uczestnik uczęszcza, informacji podanych w sekcji Krótka charakterystyka
                                        Uczestnika i jego największe osiągnięcia, które zostaną zamieszczone na stronie
                                        Enei Akademii Talentów w ramach profilu Uczestnika (z Formularza zgłoszeniowego
                                        II Etapu), www.akademiatalentow.enea.pl, celem stworzenia profilu Uczestnika i
                                        umożliwienia Internautom głosowania na danego Uczestnika i jego Zadanie
                                        konkursowe – na czas trwania Akcji oraz w ww. zakresie i celu wyraża zgodę na
                                        przetwarzanie ww. danych osobowych
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_8_error">
                                {{ agreement_8_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_9_error }" v-model="agreement_9"
                                    type="checkbox" id="flexCheckDefault-9">
                                <label class="form-check-label text-16" for="flexCheckDefault-9">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> W przypadku wygranej przez
                                        Uczestnika wyrażam zgodę na zamieszczenie przesłanego Zdjęcia zawierającego
                                        utrwalenie wizerunku Uczestnika oraz publikację danych Uczestnika, o których
                                        mowa w pkt 7) powyżej, na stronie internetowej Akcji pod adresem
                                        www.akademiatalentow.enea.pl w zakładce Zwycięzcy Akcji 2024/2025 na okres do
                                        dnia 31 grudnia 2025 roku – tj. na czas do zakończenia programu stypendialnego
                                        oraz w ww. zakresie i celu wyrażam zgodę na przetwarzanie ww. danych osobowych.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_9_error">
                                {{ agreement_9_error }}
                            </div>
                        </div>
                    </div>

                    <div class="form__row py-2" v-if="recaptcha_error">
                        <div class="text-center">
                            <p class="text-danger form__title heading-32">
                                Błąd recaptcha
                            </p>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center -pb-6">
                        <button class="button__red form__btn" @click="sendForm" :disabled="sendFormLoader">
                            <div v-if="sendFormLoader">
                                <svg style="width: 20px; height: 20px;" version="1.1" id="L9"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0"
                                    xml:space="preserve">
                                    <path fill="#fff"
                                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
                                            dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>
                            <span>Zapisz&nbsp;i&nbsp;wyślij</span>
                            <img src="@/assets/right-btn.svg" alt="" class="button__arrow" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <modal-success v-if="showModal.show" @close-modal="() => showModal.show = false" :type="showModal.type" />
        </transition>

    </div>

</template>

<script>
import ReportingPerson from "@/components/forms/ReportingPersonStudentStep2.vue";
import StudentDataStep2 from "@/components/forms/StudentDataStep2.vue";
import ModalSuccess from "@/components/forms/ModalSuccess.vue";
import AttachmentsData from "@/components/forms/AttachmentsData.vue";
import axios from "axios";

export default {
    data() {
        return {
            isParent: false,
            sendFormLoader: false,
            showModal: {
                type: 'success',
                show: false,
            },
            agreement_all: false,
            agreement_1: false,
            agreement_2: false,
            agreement_3: false,
            agreement_4: false,
            agreement_5: false,
            agreement_6: false,
            agreement_7: false,
            agreement_8: false,
            agreement_9: false,
            readMoreActivated: {},
            contactTerms: [
                {
                    id: "1",
                    description:
                        "Współadministratorem danych osobowych Wnioskodawców (wedle definicji Regulaminu Akcji dla Uczniów) Uczestników (wedle definicji regulaminu Akcji dla Uczniów), osób, których wizerunek lub głos został utrwalony w Zadaniu konkursowym oraz osób, których przedmioty praw, w tym utwory lub artystyczne wykonania zostały wykorzystane w Zadaniu konkursowym jest Enea S.A. z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań - Nowe Miasto i Wilda w Poznaniu, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000012483, NIP 777-00-20-640, REGON 630139960, kapitał zakładowy: 441 442 578 zł wpłacony w całości oraz Fundacja Enea z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000505487, NIP: 779-24-21-429, REGON: 302710647 <br> Dane osobowe będą przetwarzane zgodnie z przepisami Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE - Dz. U. UE. L. z 2016 r. Nr 119/1 (RODO) w  celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń. <br> Podstawą przetwarzania danych osobowych jest zgoda w oparciu o art. 6 ust. 1 lit. a) RODO w celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, a w zakresie danych przetwarzanych w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń, na podstawie art. 6 ust. 1 lit. f) RODO. <br> Dane osobowe będą przetwarzane do 15 marca 2025 roku, a w przypadku przyznania stypendium przez okres do 31 grudnia 2025 r., a po tym okresie – dla celów związanych z możliwością ustalenia, dochodzenia lub obrony roszczeń - przez czas niezbędny do ich ustalenia, dochodzenia lub obrony, nie dłużej jednak niż do upływu okresu przedawnienia. <br><br> Osoba, której dane dotyczą ma prawo żądania: <br> a) dostępu do treści swoich danych - w granicach art. 15 RODO, <br> b) ich sprostowania – w granicach art. 16 RODO, <br> c) ich usunięcia - w granicach art. 17 RODO, <br> d) ograniczenia przetwarzania - w granicach art. 18 RODO, <br> e) przenoszenia danych - w granicach art. 20 RODO, <br> f) wniesienia sprzeciwu wobec przetwarzania danych osobowych opartego na art. 6 ust. 1 lit. f) RODO - w granicach art. 21 RODO. <br><br> W odniesieniu do danych osobowych przetwarzanych na podstawie zgody osoba, której dane dotyczą ma prawo do cofnięcia zgody w dowolnym momencie, przy czym wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Cofnięcie zgody jest możliwe w formie pisemnej poprzez przesłanie jej na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań lub na adres mailowy esa.iod@enea.pl. <br> Współadministrator może ujawnić dane osobowe podmiotom upoważnionym na podstawie przepisów prawa. <br> Współadministrator może również powierzyć przetwarzanie danych osobowych dostawcom usług lub produktów działającym na jego rzecz, w szczególności podmiotom świadczącym Administratorowi usługi IT, księgowe, transportowe, serwisowe, agencyjne. <br> Zgodnie z zawartymi z takimi podmiotami umowami powierzenia przetwarzania danych osobowych, Współadministrator wymaga od tych dostawców usług zgodnego z przepisami prawa, wysokiego stopnia ochrony prywatności i bezpieczeństwa danych osobowych przetwarzanych przez nich w imieniu Współadministratora. <br> Współadministratorzy postanowili o ustanowieniu wspólnego punktu kontaktowego wobec czego realizacja praw, o których mowa powyżej może odbywać się poprzez wskazanie żądań przesłane na adres: esa.iod@enea.pl  lub pisemnie na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań. <br> Niezależnie od powyższego każdy ze Współadministratorów ponosi solidarną odpowiedzialność za wszelkie naruszenia w procesie przetwarzania danych.  Osoba, której dane dotyczą może zgłosić swoje roszczenia wybranemu Współadministratorowi, który będzie zobowiązany do naprawienia szkody, nawet jeśli wyrządził ją inny Współadministrator. Tym samym, osoba, której dane dotyczą, ma prawo do kierowania roszczeń przeciwko któremukolwiek ze Współadministratorów. <br> Osoba, której dane dotyczą ma prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna, iż przetwarzanie danych osobowych jej dotyczących narusza przepisy prawa dotyczące przetwarzania danych osobowych; kontakt: ul. Stawki 2, 00-193 Warszawa, tel.: 22 531 03 00, fax: 22 531 03 01, e-mail: kancelaria@uodo.gov.pl. <br> Dane osobowe nie będą przekazywane do państwa trzeciego/organizacji międzynarodowej. <br> W oparciu o dane osobowe Współadministrator nie będzie podejmował decyzji w sposób zautomatyzowany, w tym również w formie profilowania. <br><br> Administratorem danych osobowych przetwarzanych w celu wykonania Umowy stypendialnej oraz w celu przekazania Nagrody - wypłaty Stypendium, zapłaty zaliczki na podatek dochodowy  oraz w celu wystawienia przez Fundatora PIT 8C zgodnie z ustawą z dnia 26.07.1991 roku o podatku dochodowym od osób fizycznych jest Fundacja Enea z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000505487, NIP: 779-24-21-429, REGON: 302710647. Szczegółowa treść klauzuli informacyjna dołączona do wzoru Umowy stypendialnej stanowiącej załącznik do Regulaminu Akcji dla Uczniów. ",
                    checked: false,
                    required: true,
                },
            ],
        }
    },
    mounted() {
        this.$store.commit('removeAllErrors');
        this.$store.commit('resetFormStudent');
        this.isParent = this.$store.getters.getValuByPath('formStudentStep2.student.email') ? false : true;
    },
    computed: {
        agreement_1_error() {
            const error = this.$store.getters.getError('application.agreement_1');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_2_error() {
            const error = this.$store.getters.getError('application.agreement_2');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_3_error() {
            const error = this.$store.getters.getError('application.agreement_3');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_4_error() {
            const error = this.$store.getters.getError('application.agreement_4');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_5_error() {
            const error = this.$store.getters.getError('application.agreement_5');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_6_error() {
            const error = this.$store.getters.getError('application.agreement_6');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_7_error() {
            const error = this.$store.getters.getError('application.agreement_7');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_8_error() {
            const error = this.$store.getters.getError('application.agreement_8');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_9_error() {
            const error = this.$store.getters.getError('application.agreement_9');
            if (error && error.length)
                return error[0]

            return null
        },
        recaptcha_error() {
            const error = this.$store.getters.getError('grecaptcha_token');
            if (error && error.length)
                return error[0]

            return null
        }
    },
    watch: {
        agreement_all(newVal) {
            if (newVal) {
                this.agreement_1 = true;
                this.agreement_2 = true;
                this.agreement_3 = true;
                this.agreement_4 = true;
                this.agreement_5 = true;
                this.agreement_6 = true;
                this.agreement_7 = true;
                this.agreement_8 = true;
                this.agreement_9 = true;
            }
        },
        agreement_1(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_1', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_1')
        },
        agreement_2(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_2', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_2')
        },
        agreement_3(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_3', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_3')
        },
        agreement_4(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_4', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_4')
        },
        agreement_5(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_5', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_5')
        },
        agreement_6(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_6', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_6')
        },
        agreement_7(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_7', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_7')
        },
        agreement_8(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_8', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_8')
        },
        agreement_9(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudentStep2.application.agreement_9', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudentStep2.application.agreement_9')
        },
    },
    components: {
        ModalSuccess,
        // forms section
        AttachmentsData,
        ReportingPerson,
        StudentDataStep2
    },
    methods: {
        checkmarkExpand(id) {
            this.readMoreActivated[id] = true;
        },
        checkmarkCollapse(id) {
            this.readMoreActivated[id] = false;
        },
        scrollToElement() {
            setTimeout(() => {

                const el = document.querySelector('.text-danger');

                if (el) {
                    // Use el.scrollIntoView() to instantly scroll to the element
                    el.scrollIntoView({ behavior: 'smooth' });

                    const pos = el.style.position;
                    const top = el.style.top;
                    el.style.position = 'relative';
                    el.style.top = '-200px';
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    el.style.top = top;
                    el.style.position = pos;
                }
            }, 200);
        },
        async sendForm() {
            this.sendFormLoader = true;
            this.$store.commit('removeAllErrors');

            // const config = {
            //     headers: {
            //         'content-type': 'multipart/form-data'
            //     }
            // }

            await this.$recaptchaLoaded();
            // const token = await this.$recaptcha("form");
            const form = this.$store.getters.getValuByPath('formStudentStep2');
            const files = this.$store.getters.getValuByPath('files');
            let data = new FormData();

            data.append('form', JSON.stringify(form));

            for (const [key, value] of Object.entries(files)) {
                data.append(key, value);
            }
            axios
                .post(process.env.VUE_APP_API_BASE_URL + "applications/finalists/" + this.$route.params.uuid + "/store",
                    data,
                )
                .then((response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        this.showModal.type = 'success-finalist'
                        this.showModal.show = true
                    } else if (response.status == 200 && response.data.status == 'finalist-accept') {
                        this.showModal.type = 'finalist-accept'
                        this.showModal.show = true
                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        // const errorsf = error.response.data.errors.map((e) => {
                        //     console.log(e)
                        //     if (e.slice(0, 5) == 'form.') {
                        //         e.replace('form.', '')
                        //     }
                        //     return e;
                        // })
                        const errors = {};
                        for (const [key, value] of Object.entries(error.response.data.errors)) {
                            // console.log(key.slice(0, 5))
                            if (key.slice(0, 5) == 'form.') {
                                errors[key.replace('form.', '')] = value
                            } else {
                                errors[key] = value
                            }
                        }
                        this.$store.commit('setErrors', errors);
                        this.scrollToElement();

                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false
                });
        },
    },
};
</script>
